<template>
  <v-container>
    <div>
      <h1
        style="
          font-size: 20pt;
          line-height: 150%;
          margin: 5pt 0pt;
          text-align: center;
        "
      >
        <span style="font-family: 宋体; font-size: 20pt; font-weight: bold;"
          >服务</span
        ><span style="font-family: 宋体; font-size: 20pt; font-weight: bold;"
          >协议</span
        >
      </h1>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt;
          orphans: 0;
          text-align: right;
          text-indent: 24pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;"
          >2020</span
        ><span style="font-family: 宋体; font-size: 12pt;">年</span
        ><span style="font-family: 'Times New Roman'; font-size: 12pt;">3</span
        ><span style="font-family: 宋体; font-size: 12pt;">月</span>
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt;
          orphans: 0;
          text-align: justify;
          text-indent: 24pt;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 12pt;"
          >欢迎使用大材库，在您使用大材</span
        ><span style="font-family: 宋体; font-size: 12pt;">库提供</span
        ><span style="font-family: 宋体; font-size: 12pt;">的各项</span
        ><span style="font-family: 宋体; font-size: 12pt;">付费</span
        ><span style="font-family: 宋体; font-size: 12pt;">服务及非</span
        ><span style="font-family: 宋体; font-size: 12pt;">付费</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >服务（以下简称“服务”）之前，请务必仔细阅读并透彻理解本协议。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt;
          orphans: 0;
          text-align: justify;
          text-indent: 24pt;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 12pt;"
          >本协议的订立双方为</span
        ><span style="font-family: 宋体; font-size: 12pt;">大材库</span
        ><span style="font-family: 宋体; font-size: 12pt;">的实际运营商</span
        ><span style="font-family: 宋体; font-size: 12pt;">合肥机数</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >科技有限公司（下称“</span
        ><span style="font-family: 宋体; font-size: 12pt;">大材库</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >”或“我们”）与使用</span
        ><span style="font-family: 宋体; font-size: 12pt;">大材</span
        ><span style="font-family: 宋体; font-size: 12pt;">库</span
        ><span style="font-family: 宋体; font-size: 12pt;">相关</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >服务的使用人（下称“用户”或“您”），本协议是您与</span
        ><span style="font-family: 宋体; font-size: 12pt;">大材库</span
        ><span style="font-family: 宋体; font-size: 12pt;">之间关于您使用</span
        ><span style="font-family: 宋体; font-size: 12pt;">大材</span
        ><span style="font-family: 宋体; font-size: 12pt;">库</span
        ><span style="font-family: 宋体; font-size: 12pt;">提供</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >的各项服务所订立的服务条款及规则，与正式书面合同具有同等效力。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt;
          orphans: 0;
          text-align: justify;
          text-indent: 24pt;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 12pt;"
          >如您不同意本协议及其更新内容，您可以主动取消大材</span
        ><span style="font-family: 宋体; font-size: 12pt;">库提供</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >的服务；您一旦使用大材库的服务，即视为您已了解并完全同意本协议的各项内容，并成为大材库用户（以下简称“用户”）。大材库有权在必要时修改</span
        ><span style="font-family: 宋体; font-size: 12pt;">服务</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >协议，协议一旦发生变动，将会以网站公告的形式提示修改内容，变动结果将在大材</span
        ><span style="font-family: 宋体; font-size: 12pt;">库通知</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >之日起生效。如果您不同意所改动的内容，您有权停止使用大材库的服务，如果您继续使用大材库的各项服务，则视为接受服务条款的变动。用户理解并同意：由于数据行业的特殊性，大材库具有保留修改或中断部分或全部服务的权利。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt;
          orphans: 0;
          text-align: justify;
          text-indent: 24pt;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 12pt;">“大材库</span
        ><span style="font-family: 宋体; font-size: 12pt;">帐户</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >”是指您通过大材库的产品或网站注册的</span
        ><span style="font-family: 宋体; font-size: 12pt;">帐户</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >，大材库所提供的部分服务需要您在登录您的大材库</span
        ><span style="font-family: 宋体; font-size: 12pt;">帐户</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >之后使用。除本协议外，大材</span
        ><span style="font-family: 宋体; font-size: 12pt;">库发布</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >的其他相关的业务规则也是本协议的一部分，请您仔细阅读。</span
        >
      </p>
      <h3
        style="
          font-size: 14pt;
          line-height: 173%;
          margin: 13pt 0pt;
          orphans: 0;
          page-break-after: avoid;
          page-break-inside: avoid;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 14pt; font-weight: bold;"
          >一、服务内容</span
        >
      </h3>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt;
          orphans: 0;
          text-align: justify;
          text-indent: 24pt;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 12pt;">大材库</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >为用户提供优秀的数据搜索服务</span
        ><span style="font-family: 宋体; font-size: 12pt;">，</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >是一个功能强大，响应迅速的检索软件工具，该软件系统基于用户所提出和输入的指令，经过检索、分析、计算、辨识等复杂的软件系统处理后，最终生成检索结果并呈现给用户。</span
        >
      </p>
      <h3
        style="
          font-size: 14pt;
          line-height: 173%;
          margin: 13pt 0pt;
          orphans: 0;
          page-break-after: avoid;
          page-break-inside: avoid;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 14pt; font-weight: bold;"
          >二、用户注册及使用规范</span
        >
      </h3>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 38pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">1</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >大材库账号的所有权归大材库所有，您完成申请注册手续后，将获得所注册账号的使用权，该使用权仅限于您使用，您无权赠与、借用、租用、转让或售卖您的账号。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 38pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">2</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >用户应当妥善保管账户及密码信息，由于用户自身行为导致的账户或密码的泄露、遗忘等情形或其他原因所带来的损失，大材库将尽量配合用户采取积极措施降低相关损失，但因此造成的不利后果由用户自行承担。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 38pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">3</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >如果您在使用大材库所提供的服务时不能履行和遵守协议中的规定，大材库有权</span
        ><span style="font-family: 宋体; font-size: 12pt;">封闭您</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >的账号或暂时、永久禁止使用大材库，同时保留依法</span
        ><span style="font-family: 宋体; font-size: 12pt;">追究您</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >法律责任的权利，大材库</span
        ><span style="font-family: 宋体; font-size: 12pt;">将</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >保留系统内的记录，有可能作为您违反法律和本协议的证据加以保存与展示的权利。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 38pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">4</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >未经大材库许可，任何单位或个人不得通过任何方式（包括但不限于恶意注册大材库账号，机器抓取、复制、镜像等方式）不合理地获取大材库站内信息、数据等。</span
        >
      </p>
      <h3
        style="
          font-size: 14pt;
          line-height: 173%;
          margin: 13pt 0pt;
          orphans: 0;
          page-break-after: avoid;
          page-break-inside: avoid;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 14pt; font-weight: bold;"
          >三、付费用户服务条款</span
        >
      </h3>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">1</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;">大材库向付</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >费用户提供的全部服务，均仅限于付费用户在大材库平台使用，任何以恶意破解等非法手段将大材</span
        ><span style="font-family: 宋体; font-size: 12pt;">库提供</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >的服务内容与大材库平台分离的行为，均不属于本协议中约定的大材</span
        ><span style="font-family: 宋体; font-size: 12pt;">库提供</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >的服务。由此引起的一切法律后果由行为人负责，大材库将依法追究行为人的法律责任。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">2</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;">您明确</span
        ><span style="font-family: 宋体; font-size: 12pt;">了解并同意，</span
        ><span style="font-family: 宋体; font-size: 12pt;">大材库付费用</span
        ><span style="font-family: 宋体; font-size: 12pt;">户的付费方式为</span
        ><span style="font-family: 宋体; font-size: 12pt;">第三方支付</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >，您通过此种付费方式付费可能存在一定的商业风险，包括但不限于不法分子利用您账户或银行卡等有价卡进行违法活动，该等风险均会给您造成相应的经济损失。您应自行承担向侵权方追究侵权责任和追究责任不能的后果。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">3</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >您应自行负责妥善</span
        ><span style="font-family: 宋体; font-size: 12pt;">且正确</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >地保管、使用、维护您在大材库申请取得的账户、账户信息及账户密码。您应对您账户信息和账户密码采取必要和有效的保密措施，避免与第三人共享账户及相关服务信息。非大材</span
        ><span style="font-family: 宋体; font-size: 12pt;">库原因</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >致使您账户密码泄漏以及因您保管、使用、维护不当造成</span
        ><span style="font-family: 宋体; font-size: 12pt;">的</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >损失，大材库无须承担与此有关的任何责任。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">4</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >大材库不对您因第三方的行为或不作为造成的损失承担任何责任，包括但不限于支付服务和网络接入服务、任意第三方的侵权行为。</span
        >
      </p>
      <h4
        style="
          font-size: 14pt;
          line-height: 150%;
          margin: 14pt 0pt 14.5pt;
          orphans: 0;
          page-break-after: avoid;
          page-break-inside: avoid;
          text-align: justify;
          text-indent: 28.1pt;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 14pt; font-weight: bold;"
          >（一）</span
        ><span style="font-family: 宋体; font-size: 14pt; font-weight: bold;"
          >成为付费用户的方式</span
        >
      </h4>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">1</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;">在成为</span
        ><span style="font-family: 宋体; font-size: 12pt;">大材库付费用</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >户之前，您必须先根据真实、准确信息注册成为大材库用户。用户所填写的内容与个人资料必须真实有效，否则大材库有权拒绝其申请或撤销其付费用户资格，并不予任何赔偿或退还付费用户服务费。付费用户的个人资料发生变化，应及时修改注册的个人资料，否则由此造成的付费用户权利不能全面有效行使的</span
        ><span style="font-family: 宋体; font-size: 12pt;">责任由付费用</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >户自己承担，大材库有权因此取消其付费用户资格，并不</span
        ><span style="font-family: 宋体; font-size: 12pt;">予退</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >还付费用户费或其他任何形式的任何赔偿。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">2</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >用户可通过各种已有和未来新增的渠道成为大材库</span
        ><span style="font-family: 宋体; font-size: 12pt;">的</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >付费用户，包括但不限于：</span
        ><span style="font-family: 宋体; font-size: 12pt;">通过网银支付</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >、手机支付或第三方支付等方式成为付费用户。在用户使用具体某种方式成为付费用户时，须阅读并确认接受相关的服务条款和使用方法。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">3</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;">大材库付费用</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >户账号所有权归大材库所有，付费用</span
        ><span style="font-family: 宋体; font-size: 12pt;">户拥有</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >大材库账号的有限使用权。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">4</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >大材库仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、</span
        ><span style="font-family: 宋体; font-size: 12pt;">手机、</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）</span
        ><span style="font-family: 宋体; font-size: 12pt;">均应由付费用</span
        ><span style="font-family: 宋体; font-size: 12pt;">户自行负担。</span>
      </p>
      <h4
        style="
          font-size: 14pt;
          line-height: 150%;
          margin: 14pt 0pt 14.5pt;
          orphans: 0;
          page-break-after: avoid;
          page-break-inside: avoid;
          text-align: justify;
          text-indent: 28.1pt;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 14pt; font-weight: bold;"
          >（二）</span
        ><span style="font-family: 宋体; font-size: 14pt; font-weight: bold;"
          >付费用户服务和账号查询</span
        >
      </h4>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">1</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >一旦您成为大材库</span
        ><span style="font-family: 宋体; font-size: 12pt;">的</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >付费用户，即视为您认可该项服务标明</span
        ><span style="font-family: 宋体; font-size: 12pt;">的</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >价格；成为大材库</span
        ><span style="font-family: 宋体; font-size: 12pt;">的</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >付费用户后，该项服务即时生效。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">2</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >付费用户的服务标准以大材库网站上标注的详细资费标价为准，大材库对付费用户的服务有修改价格、升级服务、增减功能等权利。</span
        >
      </p>
      <h4
        style="
          font-size: 14pt;
          line-height: 150%;
          margin: 14pt 0pt 14.5pt;
          orphans: 0;
          page-break-after: avoid;
          page-break-inside: avoid;
          text-align: justify;
          text-indent: 28.1pt;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 14pt; font-weight: bold;"
          >（三）</span
        ><span style="font-family: 宋体; font-size: 14pt; font-weight: bold;"
          >付费用户的权利及限制</span
        >
      </h4>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">1</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;">大材</span
        ><span style="font-family: 宋体; font-size: 12pt;">库在此</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >声明：任何未经授权销售</span
        ><span style="font-family: 宋体; font-size: 12pt;">大材库付费用</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >户的属于无权销售</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >行为，大材库有权追究其法律责任并同时封</span
        ><span style="font-family: 宋体; font-size: 12pt;">停相关</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >账户的权利，因此产生的任何损失由行为人自行承担。付费用户服务仅限于申请账号自行使用；付费用户激活后服务期内不能在大材库</span
        ><span style="font-family: 宋体; font-size: 12pt;">帐号</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >之间转移，禁止赠与、借用、转让或售卖。否则大材库有权在未经通知的情况下取消转让账户、受让账户的付费用户服务资格，由此带来的</span
        ><span style="font-family: 宋体; font-size: 12pt;">损失由付费用</span
        ><span style="font-family: 宋体; font-size: 12pt;">户自行承担。</span>
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">2</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >大材库付费账号同一时间同一账号仅可在</span
        ><span style="font-family: 'Times New Roman'; font-size: 12pt;">1</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >台设备上登录使用，超出上述范围使用的，将被强制下线。用户应当自行承担超范围使用而导致的任何损失，同时大材库保留追究上述行为人法律责任的权利。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">3</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;">若付费用</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >户的行为持续违反本协议或违反国家相关法律法规，或大材</span
        ><span style="font-family: 宋体; font-size: 12pt;">库认为</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >付费用户行为有损大材库或他人的声誉及利益，大材</span
        ><span style="font-family: 宋体; font-size: 12pt;">库公司</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >有权取消该付费用户的付费用</span
        ><span style="font-family: 宋体; font-size: 12pt;">户资格</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >而无须给与任何补偿。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">4</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >付费用户不得以盗窃、利用系统漏洞等非法途径以及在未获大材库授权的非法销售</span
        ><span style="font-family: 宋体; font-size: 12pt;">大材库付费用</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >户的网站上获取或购买付费用户服务，否则大材库有权取消付费用户的服务资格。由此引发的</span
        ><span style="font-family: 宋体; font-size: 12pt;">问题由付费用</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >户自行承担，大材库不负任何责任。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt 0pt 0pt 58pt;
          orphans: 0;
          text-align: justify;
          text-indent: -18pt;
          widows: 0;
        "
      >
        <span style="font-family: 'Times New Roman'; font-size: 12pt;">5</span
        ><span style="font-family: 宋体; font-size: 12pt;">、</span
        ><span style="font: 7pt 'Times New Roman';">&#xa0; </span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >任何付费用户不得使用带有非法、淫秽、污辱或人身攻击的含义污辱或人身攻击的用户名，一经发现，大材库有权取消其付费用</span
        ><span style="font-family: 宋体; font-size: 12pt;">户资格</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >而无需给与任何补偿和退费。</span
        >
      </p>
      <h3
        style="
          font-size: 14pt;
          line-height: 173%;
          margin: 13pt 0pt;
          orphans: 0;
          page-break-after: avoid;
          page-break-inside: avoid;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 14pt; font-weight: bold;"
          >四、</span
        ><span style="font-family: 宋体; font-size: 14pt; font-weight: bold;"
          >版权政策</span
        >
      </h3>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt;
          orphans: 0;
          text-align: justify;
          text-indent: 24pt;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 12pt;"
          >除非大材库另行声明，大材库平台内的本网站（</span
        ><span style="font-family: 'Times New Roman'; font-size: 12pt;"
          >www.dcaiku.com</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >）的所有产品、技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有权利</span
        ><span style="font-family: 宋体; font-size: 12pt;">，</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >所有知识产权（包括但不限于版权、商标权、专利权、商业秘密及其他所有相关权利）均归大材库或其关联公司所有。未经大材库许可，任何人不得擅自使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载）大材库平台内的任何内容。</span
        >
      </p>
      <p
        style="
          font-size: 12pt;
          line-height: 150%;
          margin: 0pt;
          orphans: 0;
          text-align: justify;
          text-indent: 24pt;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 12pt;">大材</span
        ><span style="font-family: 宋体; font-size: 12pt;">库尊重</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >知识产权，反对侵权盗版行为。未经大材库许可，任何人不得擅</span
        ><span style="font-family: 宋体; font-size: 12pt;"
          >自（包括但不限于：以非法的方式复制、传播、展示、镜像、上载、下载）使用，或通过非常规方式（如：恶意干预大材库数据）影响大材库的正常服务，任何人不得擅自以软件程序自动获得大材库数据。否则，大材库有权依法追究其法律责任。</span
        >
      </p>
      <h3
        style="
          font-size: 14pt;
          line-height: 173%;
          margin: 13pt 0pt;
          orphans: 0;
          page-break-after: avoid;
          page-break-inside: avoid;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-family: 宋体; font-size: 14pt; font-weight: bold;"
          >五、</span
        ><span style="font-family: 宋体; font-size: 14pt; font-weight: bold;"
          >声明接受</span
        >
      </h3>
      <ol type="1" style="margin: 0pt; padding-left: 0pt;">
        <li
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            line-height: 150%;
            margin: 0pt 0pt 0pt 55pt;
            orphans: 0;
            padding-left: 4pt;
            text-align: justify;
            text-indent: 0pt;
            widows: 0;
          "
        >
          <span style="font-family: 宋体; font-size: 12pt;"
            >用户在使用大材库前对本声明的条款已充分阅读，就声明的条款内容进行了充分沟通。用户已完整、清晰的理解每一条款的真实含义，对声明的条款约定的双方权利义务均不存在异议与保留意见。</span
          >
        </li>
        <li
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            line-height: 150%;
            margin: 0pt 0pt 0pt 55pt;
            orphans: 0;
            padding-left: 4pt;
            text-align: justify;
            text-indent: 0pt;
            widows: 0;
          "
        >
          <span style="font-family: 宋体; font-size: 12pt;"
            >双方在此确认就本声明的条款内容，不存在重大误解、欺诈胁迫等可能导致本声明的条款可撤销或自始无效等效力瑕疵事宜。明确放弃基于上述及类似理由产生的撤销权。</span
          >
        </li>
        <li
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            line-height: 150%;
            margin: 0pt 0pt 0pt 55pt;
            orphans: 0;
            padding-left: 4pt;
            text-align: justify;
            text-indent: 0pt;
            widows: 0;
          "
        >
          <span style="font-family: 宋体; font-size: 12pt;"
            >用户在使用大材库网站或软件时即代表其已经声明基于真实有效的意思表示，接受本声明的条款。</span
          >
        </li>
        <li
          style="
            font-family: 'Times New Roman';
            font-size: 12pt;
            line-height: 150%;
            margin: 0pt 0pt 0pt 55pt;
            orphans: 0;
            padding-left: 4pt;
            text-align: justify;
            text-indent: 0pt;
            widows: 0;
          "
        >
          <span style="font-family: 宋体; font-size: 12pt;"
            >本协议条款的最终解释权归大材库所有。</span
          >
        </li>
      </ol>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Service",
};
</script>

<style scoped></style>
